import React, { useEffect, useState } from 'react'

import TeacherVolumeTestFailed from './TeacherVolumeTestFailed'
import TeacherVolumeTestResultSuccess from './TeacherVolumeTestResultSuccess'

import { VOLUME_CHECK_EVENTS } from '../StudentVolumeChecksConstants'

import useStudentPreChecks from '../../useStudentPreChecks'
import StudentInstruction from '../../Components/StudentInstruction'
import { PRE_CHECK_MACHINE_STATES } from '../../constants'
import PreCheckTeacherModal from '../../Components/PreCheckTeacherModal'
import RaiseHand from '../../Components/PreCheckIllustrations/RaiseHand'
import Microphone from '../../Components/PreCheckIllustrations/Microphone'
import { getCopyByGradeband } from '../../../../services/ThemingService'
import { COPY_STRINGS } from '../../../../constants/translatedCopy'

export default function VolumeCheckTeacherModal({ volumeStats, studentDidSaySomething, handleRetry, isTeacherMode, toggleTeacherMode, teacherTestSuccessful, logVolumeCheckFailure }) {

  const { logEvent, addTroubleshootData } = useStudentPreChecks({ itemToCheck: PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks })

  const [ inTroubleshootView, setInTroubleshootView ] = useState(isTeacherMode)

  useEffect(()=>{
    if(!isTeacherMode){
      logEvent(VOLUME_CHECK_EVENTS.CALLED_TEACHER)
      // Log to Sentry when teacher is called for volume check help
      if (logVolumeCheckFailure) {
        logVolumeCheckFailure('TEACHER_CALLED', {
          studentDidSaySomething: studentDidSaySomething.current,
          volumeStats: volumeStats
        });
      }
    }
    if(!studentDidSaySomething.current){
      addTroubleshootData({
        ready_handle_no_volume:{
          volumeSnapshot: volumeStats
        }
      })
      if(isTeacherMode){
        logEvent(VOLUME_CHECK_EVENTS.TEACHER_NO_VOLUME_DETECTED)
      }else{
        logEvent(VOLUME_CHECK_EVENTS.NO_VOLUME_DETECTED)
      }
    }
  }, [])

  const copy_strings = getCopyByGradeband(COPY_STRINGS, "student_raise_hand"); 

  const StudentView = () => <StudentInstruction>
      <RaiseHand/>
      <p>{copy_strings.title}</p>
    </StudentInstruction>

  const TroubleshootView = () => {
    return <StudentInstruction>
      <p>Please put on the headset to help test the microphone volume.</p>
      <Microphone/>
      <button className="test-mic-button" onClick={testMicrophone}>Test Microphone</button>
    </StudentInstruction>
  }

  const testMicrophone = async () => {
    if(!isTeacherMode){
      await toggleTeacherMode(true)
      logEvent(VOLUME_CHECK_EVENTS.TEACHER_TEST_STARTED)
    }
    handleRetry()
  }

  const retry = () => {
    logEvent(isTeacherMode ? VOLUME_CHECK_EVENTS.TEACHER_RETRY : VOLUME_CHECK_EVENTS.RETRY) 
    handleRetry()
  }

  if(inTroubleshootView){
    if(isTeacherMode){
      if(teacherTestSuccessful.current){
        return <TeacherVolumeTestResultSuccess toggleTeacherMode={toggleTeacherMode}/>
      }
      return <TeacherVolumeTestFailed handleRetry={retry}/>
    }
    return <TroubleshootView/>
  }

  return (
      <PreCheckTeacherModal
        setInTroubleshootView={setInTroubleshootView}
        StudentView={StudentView}
        handleRetry={retry}
      />
  )
}
